import SeeMore from "../../../shared/SeeMore";

const InfoBankStep = () => {
    return (
        <SeeMore>
            <strong>Por que precisamos dos seus dados bancários?</strong>
            <p>
                É para esta conta que a MaxMilhas fará o pagamento das milhas utilizadas nas emissões.
            </p>
            <p>
                Para isso, é preciso cadastrar uma conta corrente que tenha o mesmo titular da conta na MaxMilhas.
            </p>
            <strong>Sigilo e segurança dos seus dados</strong>
            <p>
            Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em 
            segurança. Aqui, seus dados estão protegidos.
            </p>
        </SeeMore>
    );
}

export default InfoBankStep;